import React from 'react'
import { FC } from 'react'
import { DataGridCell } from '@imodules/react-components/controls/DataGridCell'

export interface DesignationCellProps {
    data: any
    parentFormId: number
    parentFormBaseUrl: string
    designationId: string | undefined
    appealCode: string
}

export const DesignationCell: FC<DesignationCellProps> = props => (
    <DataGridCell
        className="scoreboard-designation-column data-grid-column "
        widthType={{ kind: 'width', width: 1 }}
        isColumnHeader={false}
    >
        {
            props.parentFormId
                ? <a href={generateUrl(props.parentFormBaseUrl, props.designationId, props.appealCode)}>{props.data}</a>
                : props.data
        }
    </DataGridCell>
)

const generateUrl = (baseUrl: string, did: string | undefined, appeal: string) => {
    let url = baseUrl
    if (did) {
        url += `&dids=${did}&bledit=1`
    }
    if (appeal) {
        url += `&appealcode=${appeal}`
    }
    return url
}
